import DDLogs from '../../DDLogs';

const state = {
  isConnected: false,
  socketMessage: '',
};

const mutations = {
  socket_connect(state) {
    DDLogs.log('Socket Connect');
    state.isConnected = true; // eslint-disable-line
  },

  socket_versionUpdated(state, message) {
    DDLogs.log(`Socket version updated ${message}`);
    state.socketMessage = message; // eslint-disable-line
  },

  socket_disconnect(state, reason) {
    DDLogs.log(`Socket Disconnect - reason ${reason}`);
    state.isConnected = false; // eslint-disable-line
  },

  socket_error(state, error) {
    DDLogs.log(`Socket error ${error}`);
  },

  socket_reconnect(state, reconnect) {
    DDLogs.log('Socket reconnect', reconnect);
  },

  socket_reconnect_error(state, error) {
    DDLogs.log(`Socket reconnect error ${error}`);
  },

  socket_reconnect_failed(state) {
    DDLogs.log('Socket reconnect failed');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/websocket.js